<template>
  <v-card class="rounded-lg">
    <!-- Header -->
    <v-card-title class="d-flex justify-space-between align-center">
      <div class="font-weight-bold">
        <v-icon size="18" class="me-1">mdi-sitemap-outline</v-icon>
        Folder Tree
      </div>

      <v-btn
        icon
        size="small"
        variant="text"
        @click="reload"
      >
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
    </v-card-title>

    <v-divider />

    <!-- Tree -->
    <v-card-text class="pt-2">
      <v-treeview
        :items="tree"
        item-title="name"
        item-value="id"
        activatable
        open-on-click
        density="compact"
        expand-icon=""
        @update:activated="onSelect"
      >
        <!-- Folder icon only (no expand chevron) -->
        <template #prepend="{ item, isOpen }">
          <v-icon size="18">
            {{ isOpen ? 'mdi-folder-open' : 'mdi-folder' }}
          </v-icon>
        </template>

        <!-- Actions -->
        <template #append="{ item }">
          <v-menu>
            <template #activator="{ props }">
              <v-btn
                icon
                size="x-small"
                variant="text"
                v-bind="props"
              >
                <v-icon size="16">mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list density="compact">
              <v-list-item @click="$emit('rename', item)">
                <v-icon start size="16">mdi-pencil</v-icon>
                Rename
              </v-list-item>
              <v-list-item class="text-red" @click="remove(item)">
                <v-icon start size="16">mdi-delete</v-icon>
                Delete
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-treeview>
    </v-card-text>
  </v-card>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import axios from 'axios';
import { prefix } from '@/store/api';

const emit = defineEmits(['select', 'rename', 'refresh'])

const folders = ref([])
const tree = ref([])

/**
 * Load folders from API
 */
const loadFolders = async () => {
  const { data: response } = await axios.get(`${prefix}cms/folders`)
  folders.value = response.data
  tree.value = buildTree(response.data)
}

const buildTree = (items, parentId = null) => {
  return items
    .filter(i => i.parent_id === parentId)
    .map(i => ({
      ...i,
      children: buildTree(items, i.id),
    }))
}

const onSelect = (ids) => {
  if (!ids.length) return
  const folder = folders.value.find(f => f.id === ids[0])
  emit('select', folder.id, folder.name)
}

const remove = async (folder) => {
  if (!confirm('Delete this folder?')) return
  await axios.delete(`${prefix}cms/folders/${folder.id}`)
  reload()
}

const reload = async () => {
  await loadFolders()
  emit('refresh')
}

onMounted(loadFolders)

/* expose reload() to parent */
defineExpose({ reload })

</script>

<style scope> 
  .v-list-item-action {
    display: none !important;
  }
  .v-treeview-node__toggle {
    display: none !important;
  }

  /* Remove left padding reserved for chevron */
  .v-treeview-node__level {
    padding-left: 8px !important;
  }
</style>
